import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PageYusenVantage(props) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/tracking');
  }, [])

  window.open(`https://rt.yusen-logistics.com/yusenvantagefocus/auth/login`);
  return (
    <div className = 'page-yusen-vantage'>
      ...redirect to Yusen Vantage...
    </div>
  );
}
